import React, { useState, useEffect } from 'react';
import './custom-style.css';
import TmiIcon from '../assets/TMI-icon.png';
import profile from '../assets/profile.png';
import sendicon from '../assets/send-icon.png';
import StamIcon from '../assets/stam-icon.png';

const SimulationCard = ({ sessionId, sourceEvent, measures, tfv, createdAt, state }) => {
  const [publishStatus, setPublishStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [localMeasures, setLocalMeasures] = useState(measures || []);

  useEffect(() => {
    console.log("Mise à jour des mesures :", measures);
    setLocalMeasures(measures || []);
  }, [measures]);

  const handlePublishClick = async () => {
    setLoading(true);
    let response;

    try {
      const token = localStorage.getItem('authToken');
      const profileCode = localStorage.getItem('profile_code');

      response = await fetch(
        `${window.env.NM_MEASURE_GW_API_BASE_URL}/api/1/flow/stam/${profileCode}?sessionId=${sessionId}`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`.trim(),
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ sessionId }),
        }
      );

      const contentType = response.headers.get('content-type') || '';

      if (response.ok) {
        const result = contentType.includes('application/json')
          ? await response.json()
          : {};

        console.log("Réponse du backend (success):", result);
        setPublishStatus('Measure successfully published');

        if (result.measures) {
          setLocalMeasures(result.measures);
        }

      } else {
        const errorText = await response.text();
        console.error("Erreur lors de la publication:", errorText);
        setPublishStatus(` ${errorText}`);
      }

    } catch (error) {
      console.error("Erreur réseau ou inconnue:", error.message || error);
      setPublishStatus("network error");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="simulation-card border text-white">
      <div className="card-header-bar absolute top-0 left-0 w-full bg-bluegrey-900 text-white py-2 px-2 flex justify-between items-center">
        <img src={TmiIcon} alt="TMI Icon" className="w-7 h-7" />
        <span>{sourceEvent?.name}</span>
        <span className="font-regular pending-button">{state}</span>
      </div>

      <div className="tmi-blue-bar"></div>
      <div className="p-1">
        <div className="flex justify-between items-center">
          <div className="flex space-x-9">
            <p className="text-lg font-light">
              {new Date(createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </p>
            <p className="text-lg">{sourceEvent?.name}</p>
            <div className="flex items-center space-x-1">
              <img src={profile} alt="profile" className="w-5 h-5" />
              <p className="text-lg">{sourceEvent?.origin}</p>
            </div>
          </div>
          <div className="flex justify-between items-center">
            <span className="font-regular green-button">
              {localMeasures.length > 0 ? localMeasures[0]?.creationStatus || "N/A" : "Aucune mesure"}
            </span>


          </div>
        </div>
      </div>


      <div className="mt-1 space-y-1 text-gray-300">
        <div className="content-row flex justify-between items-center">
          <p className="font-regular">TFV: <span className="text-gray-400">{tfv}</span></p>
          <p className="font-regular">Reason: <span className="text-gray-400">{sourceEvent?.reason || '---'}</span></p>
          <p className="font-semi-bold text-gray-400">
            Eq CO2: <span className="text-orange-600">+ {localMeasures[0]?.co2 || 'N/A'}</span>
          </p>
        </div>

        <div className="content-row flex justify-between items-center">
          <p>
            <span className="font-regular text-white">Time: <span className="text-gray-400">{sourceEvent?.reason || '---'}</span></span>
          </p>
        </div>

        <div>
          <span className="font-regular text-white">Measures :</span> {localMeasures.length}
          <p className="font-regular">
            Comment: <span className="text-gray-400">{sourceEvent?.reason || '---'}</span>
          </p>
        </div>

        <div className="stam-container">
          {localMeasures.map((measure, index) => (
            <div className="stam-item" key={index}>
              <img src={StamIcon} alt="Stam Icon" className="w-4 h-4 mr-2" />
              <span className="text-sm">
                STAM - {measure.type} on flight {measure.flight?.callsign || 'N/A'}
                {measure.creationStatus ? ` status: ${measure.creationStatus}` : ""}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="card-footer-bar absolute bottom-0 left-0 w-full bg-bluegrey-900 text-white py-2 px-2 flex justify-between items-center">
        <button
          onClick={handlePublishClick}
          className={`publish-button flex items-center text-white font-bold py-2 px-4 rounded
    ${loading || localMeasures.length === 0 ? "bg-gray-500 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-700"}
  `}
          disabled={loading || localMeasures.length === 0}
        >
          <img src={sendicon} alt="Send Icon" className="w-5 h-4" />
          {loading ? "Publishing..." : "Publish to NM"}
        </button>

        {publishStatus && <p className="text-sm">{publishStatus}</p>}
      </div>
    </div>
  );
};

export default SimulationCard;
